import { Locale } from 'chaika-enums';
export const informedConsentTemplate = {
    template: {
        [Locale.Ru]: 'Шаблон',
        [Locale.Am]: 'Ձևանմուշ',
        [Locale.En]: 'Template',
        [Locale.Pt]: 'Modelo',
        [Locale.Ge]: 'ნიმუში',
    },
    preview: {
        [Locale.Ru]: 'Предпросмотр',
        [Locale.Am]: 'Նախադիտում',
        [Locale.En]: 'Preview',
        [Locale.Pt]: 'Visualização',
        [Locale.Ge]: 'გადახედვა',
    },
    controls: {
        [Locale.Ru]: 'Опции',
        [Locale.Am]: 'Ընտրանքներ',
        [Locale.En]: 'Controls',
        [Locale.Pt]: 'Controles',
        [Locale.Ge]: 'პარამეტრები',
    },
    versions: {
        [Locale.Ru]: 'Версии',
        [Locale.Am]: 'Տարբերակներ',
        [Locale.En]: 'Versions',
        [Locale.Pt]: 'Versões',
        [Locale.Ge]: 'ვერსიები',
    },
    templateActivationDate: {
        [Locale.Ru]: 'Дата активации шаблона',
        [Locale.Am]: 'Ձևանմուշի ակտիվացման ամսաթիվ',
        [Locale.En]: 'Template activation date',
        [Locale.Pt]: 'Data de ativação do modelo',
        [Locale.Ge]: 'შაბლონის გააქტიურების თარიღი',
    },
    createNewVersion: {
        [Locale.Ru]: 'Создать новую версию',
        [Locale.Am]: 'Ստեղծել նոր տարբերակ',
        [Locale.En]: 'Create new version',
        [Locale.Pt]: 'Criar nova versão',
        [Locale.Ge]: 'შექმენით ახალი ვერსია',
    },
};
